import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import authenticate from '@/auth/authenticate'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {

          path: '/app/sessions',
          component: () => import('@/views/app/sessions/Sessions'),

          children: [
            {
              path: 'sign-in',
              name: 'login',
              component: () => import('@/views/app/sessions/SignIn'),
            },
            {
              path: 'RememberPassword',
              name: 'RememberPassword',
              component: () => import('@/views/app/sessions/RememberPassword'),
            },
    ],
    },
        {
          path: '/',
          component: () => import('@/views/app/Index'),
          beforeEnter: authenticate,
          redirect: '/app/dashboard/statistics',

          children: [
            {
          path: '/app/dashboard',
          component: () => import('@/views/app/dashboard/Index'),

          children: [
            {
              path: 'statistics',
              name: 'statistics',
              meta: {
                breadcrumb: [{ name: 'Dashboard' }, { name: 'Statistics' }],
              },
              component: () => import('@/views/app/dashboard/Statistics'),
            },
          ],
        },
        {
          path: '/app/administration',
          component: () => import('@/views/app/administration/Index'),
          children: [
            {
              path: 'clientsConfig',
              name: 'clientsConfig',
              meta: {
                breadcrumb: [{ name: 'ClientsConfig' }, { name: 'clientsConfig' }],
                requiresPermission: 'Configuración Clientes',
              },
              component: () => import('@/views/app/administration/ClientsConfig'),
            },
            {
              path: 'tefConfig',
              name: 'tefConfig',
              meta: {
                breadcrumb: [{ name: 'TefConfig' }, { name: 'tefConfig' }],
                requiresPermission: 'Configuración TEF',
              },
              component: () => import('@/views/app/administration/TefConfig.vue'),
            },
            {
              path: 'tefConfigTerminals',
              name: 'tefConfigTerminals',
              meta: {
                breadcrumb: [{ name: 'TefConfigTerminals' }, { name: 'tefConfigTerminals' }],
              },
              component: () => import('@/views/app/administration/components/TefConfigTerminals.vue'),
            },
            {
              path: 'tefBines',
              name: 'tefBines',
              meta: {
                breadcrumb: [{ name: 'TefBines' }, { name: 'tefBines' }],
              },
              component: () => import('@/views/app/administration/components/TefBines.vue'),
            },
            {
              path: 'tefTransactionsHistory',
              name: 'tefTransactionsHistory',
              meta: {
                breadcrumb: [{ name: 'TefTransactionsHistory' }, { name: 'tefTransactionsHistory' }],
                requiresPermission: 'Historial Transacciones TEF',
              },
              component: () => import('@/views/app/administration/TefTransactionsHistory.vue'),
            },
            {
              path: 'firmasConfig',
              name: 'firmasConfig',
              meta: {
                breadcrumb: [{ name: 'FirmasConfig' }, { name: 'firmasConfig' }],
                requiresPermission: 'Firmas Electrónicas',
              },
              component: () => import('@/views/app/administration/FirmasConfig'),
            },
            {
              path: 'userConfig',
              name: 'userConfig',
              meta: {
                breadcrumb: [{ name: 'UserConfig' }, { name: 'userConfig' }],
                requiresPermission: 'Configuración Usuarios',
              },
              component: () => import('@/views/app/administration/UserConfig'),
            },
            {
              path: 'downloadXML',
              name: 'downloadXML',
              meta: {
                breadcrumb: [{ name: 'DownloadXML' }, { name: 'downloadXML' }],
                requiresPermission: 'Descarga XMLS',
              },
              component: () => import('@/views/app/administration/DownloadXML'),
            },
            {
              path: 'loadXML',
              name: 'loadXML',
              meta: {
                breadcrumb: [{ name: 'LoadXML' }, { name: 'loadXML' }],
                requiresPermission: 'Procesar XMLS',
              },
              component: () => import('@/views/app/administration/LoadXML'),
            },
            {
              path: 'Logs',
              name: 'Logs',
              meta: {
                breadcrumb: [{ name: 'Logs' }, { name: 'Logs' }],
                requiresPermission: 'Logs',
              },
              component: () => import('@/views/app/administration/Logs'),
            },
            {
              path: 'parametros',
              name: 'Parametros',
              meta: {
                breadcrumb: [{ name: 'Parametros' }, { name: 'parametros' }],
                requiresPermission: 'Parámetros Sistema',
              },
              component: () => import('@/views/app/administration/ParametrosConfig'),
            },
          ],
        },
        {
          path: '/app/invoices',
          component: () => import('@/views/app/invoices/Index'),
          children: [
            {
              path: 'reportInvoices',
              name: 'reportInvoices',
              meta: {
                breadcrumb: [{ name: 'ReportInvoices' }, { name: 'reportInvoices' }],
                requiresPermission: 'Reporte Facturas',
              },
              component: () => import('@/views/app/invoices/ReportInvoices'),
            },
            {
              path: 'managementInvoices',
              name: 'managementInvoices',
              meta: {
                breadcrumb: [{ name: 'ManagementInvoices' }, { name: 'managementInvoices' }],
                requiresPermission: 'Gestión Facturación',
              },
              component: () => import('@/views/app/invoices/ManagementInvoices'),
            },
            {
              path: 'atsProcessing',
              name: 'atsProcessing',
              meta: {
                breadcrumb: [{ name: 'AtsProcessing' }, { name: 'atsProcessing' }],
                requiresPermission: 'Procesamiento ATS',
              },
              component: () => import('@/views/app/invoices/AtsProcessing'),
            }
          ],
        },
        {
          path: '/app/wide-events',
          component: () => import('@/views/app/wideEvents/Index'),
          children: [
            {
              path: 'dashboard',
              name: 'wideEventsDashboard',
              meta: {
                breadcrumb: [{ name: 'Trazabilidad' }, { name: 'Monitoreo de Eventos' }],
                requiresPermission: 'Trazabilidad',
              },
              component: () => import('@/views/app/wideEvents/WideEventsDashboard'),
            },
            {
              path: 'search',
              name: 'wideEventsSearch',
              meta: {
                breadcrumb: [{ name: 'Trazabilidad' }, { name: 'Búsqueda' }],
                requiresPermission: 'Trazabilidad',
              },
              component: () => import('@/views/app/wideEvents/WideEventsSearch'),
            },
            {
              path: 'detail/:traceId',
              name: 'wideEventDetail',
              meta: {
                breadcrumb: [{ name: 'Trazabilidad' }, { name: 'Detalle Evento' }],
                requiresPermission: 'Trazabilidad',
              },
              component: () => import('@/views/app/wideEvents/WideEventDetail'),
            },
            {
              path: 'errors',
              name: 'wideEventsErrors',
              meta: {
                breadcrumb: [{ name: 'Trazabilidad' }, { name: 'Análisis de Errores' }],
                requiresPermission: 'Trazabilidad',
              },
              component: () => import('@/views/app/wideEvents/WideEventsErrors'),
            },
          ],
        },
        {
          path: '/app/user/roles-permisos',
          name: 'RolesAndPermissions',
          meta: {
            requiresPermission: 'Roles Y Permisos',
          },
          component: () => import('@/views/app/user/RolesAndPermissions'),
        },
        {
          path: '/app/error/forbidden',
          name: 'forbidden',
          component: () => import('@/views/app/error/Forbidden.vue'),
        },
      ],
    },

  ],
})

router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  if (to.path) {
    // Start the route progress bar.
    store.dispatch('changeThemeLoadingState', true)
  }
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  if (to.meta.requiresPermission) {
    if (!permissions.includes(to.meta.requiresPermission)) {
      // 🚫 Redirigir a la vista de “Acceso denegado”
      return next('/app/error/forbidden');
    }
  }
  next()
})

router.afterEach(() => {
  // Remove initial loading
  // const gullPreLoading = document.getElementById("loading_wrap");
  // if (gullPreLoading) {
  //   gullPreLoading.style.display = "none";
  // }
  // Complete the animation of the route progress bar.
  setTimeout(() => store.dispatch('changeThemeLoadingState', false), 500)
  // NProgress.done();
  // if (isMobile) {
  // if (window.innerWidth <= 1200) {
  //   // console.log("mobile");
  //   store.dispatch("changeSidebarProperties");
  //   if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
  //     store.dispatch("changeSecondarySidebarProperties");
  //   }
  //   if (store.getters.getCompactSideBarToggleProperties.isSideNavOpen) {
  //     store.dispatch("changeCompactSidebarProperties");
  //   }
  // } else {
  //   if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
  //     store.dispatch("changeSecondarySidebarProperties");
  //   }
  //   // store.state.sidebarToggleProperties.isSecondarySideNavOpen = false;
  // }
})

export default router
